module.exports = __webpack_public_path__ + "static/media/me-1.b2fb9f64.svg";